<script>
export default {
  name: "examineSetting",
  data() {
    return {
      form: {
        config: []
      }
    }

  },
  mounted() {
    this.getInitFn()
  },
  methods: {
    async getInitFn() {
      const url = '/api/v1/manage/referrer/settle/config'
      const {code, data} = await this.$axios.get(url)
      if (code === 1) {
        this.$set(this.form, 'config', data || [])
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const url = '/api/v1/manage/referrer/settle/config'
          const {code} = await this.$axios.post(url, {
            config: JSON.stringify(this.form.config)
          })
          if (code === 1) {
            this.$message.success('操作成功')
            this.$emit('handClose')
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<template>
  <div class="examineSetting">
    <el-form label-position="left" :model="form" ref="form" label-width="120px">
      <el-form-item
          v-for="(domain, index) in form.config"
          :label="domain.organizationName"
          :key="index"
      >
        <el-radio-group v-model="domain.autoSettleConfig">
          <el-radio :label="1">人工通过审核</el-radio>
          <el-radio :label="2">自动通过审核</el-radio>
        </el-radio-group>

      </el-form-item>
      <p class="util-money">注意：开启自动通过审核，发起提现后即自动审核通过并转账</p>

      <el-form-item>
        <div class="flex-end">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<style scoped lang="less">

</style>